module.exports = __webpack_public_path__ + "img/sber.4e639040.svg";